const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;
export { API_ENDPOINT, BASE_URL, CAPTCHA_KEY };
